<template>
  <v-card>
    <validation-observer v-slot="{ handleSubmit }">
      <v-card-text class="d-flex align-center justify-space-between pl-10">
        <span v-if="code.type == promotionGeneral">Thêm lượt sử dụng</span>
        <span v-if="code.type == promotionPrivate">Thêm mã</span>
        <v-btn color="default" class="ma-0" small icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-text>
      <v-row>
        <v-col cols="10" offset="1" class="py-0">
          <validation-provider
            v-if="code.type == promotionGeneral"
            v-slot="{ errors }"
            class="mb-2"
            :rules="{ min_value: 0, alpha_num: true, max: 6 }"
            :name="'Số lượt sử dụng muốn thêm'"
          >
            <v-text-field
              class="text-field text-field-number"
              :error-messages="errors"
              :clearable="true"
              placeholder="Nhập số lượng"
              outlined
              dense
              type="number"
              :label="'Nhập số lượt sử dụng muốn thêm'"
              v-model="additionNumber"
            ></v-text-field>
          </validation-provider>

          <validation-provider
            v-if="code.type == promotionPrivate"
            v-slot="{ errors }"
            class="mb-2"
            :rules="{ min_value: 0, max_value: (100000 < code.numberOfAvailablePromotionSub) ? 100000 : code.numberOfAvailablePromotionSub, alpha_num: true, max: 6 }"
            :name="'Số mã muốn tạo thêm'"
          >
            <v-text-field
              class="text-field text-field-number"
              :error-messages="errors"
              :clearable="true"
              placeholder="Nhập số mã"
              outlined
              dense
              type="number"
              :label="'Nhập số mã muốn tạo thêm'"
              v-model="additionNumber"
            ></v-text-field>
          </validation-provider>
          <b v-if="code.type == promotionPrivate && 100000 < code.numberOfAvailablePromotionSub">Số mã tối đa có thể tạo thêm: 100000</b>
          <b v-if="code.type == promotionPrivate && code.numberOfAvailablePromotionSub < 100000">Số mã tối đa có thể tạo thêm: {{ code.numberOfAvailablePromotionSub }}</b>

          <v-card-actions class="d-flex justify-center">
            <v-btn
              color="success"
              class="mr-2"
              small
              @click.prevent="handleSubmit(saveCode)"
              :disabled="isPending"
            >Thêm</v-btn>

            <v-btn
              class="btn-cancel mx-0"
              small
              @click="cancel"
            >
              Hủy
            </v-btn>

          </v-card-actions>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>
<script>
import {
  promotionGeneral,
  promotionPrivate,
} from '../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const PromotionRepository = RepositoryFactory.get('promotion');

export default {
  name: 'add-code-modal',
  props: {
    code: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      additionNumber: null,
      isPending: false,
      promotionGeneral,
      promotionPrivate,
    };
  },
  methods: {
    async saveCode() {
      const body = {
        additionNumber: this.additionNumber,
      };
      if (!this.additionNumber || this.additionNumber === '0') {
        this.additionNumber = null;
        return this.$emit('close');
      }
      this.isPending = true;
      const res = await PromotionRepository.addition(this.code.id, body);
      this.isPending = false;
      if(res.data && res.data.id) {
        this.$swal({
          type: 'success',
          icon: "success",
          text: 'Yêu cầu thêm mã thành công',
          toast: true,
          timer: 1500,
        });
        this.additionNumber = null;
        return this.$emit('success', res.data);
      }
      this.$swal({
        type: 'error',
        icon: "error",
        text: res.errors.message,
      });
    },
    close() {
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    },
  }
}
</script>